var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-edit"},[_c('paragraph',{attrs:{"type":"Container","emit":"client.component.show"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/ContainerBox/ContainerBox.vue